import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
// import {

// 	Button,
// 	Box,

// 	TextField,
// 	Typography,
// } from "@mui/material";
// import { makeStyles } from "@mui/styles";
// //import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import MuiAlert from "@mui/lab/Alert";
// function Alert(props) {
// 	return <MuiAlert elevation={6} variant="filled" {...props} />;
// }
//const useStyles = makeStyles((theme) => ({}));
export default function SellerDetailsStep3({
	upperState,
	setUpperState,
	setBackDrop,

	setSnackState,
}) {
	// const [complete, setComplete] = useState(false);
	// //const [selectedDate, handleDateChange] = useState(new Date());
	// const handleChangeCheckbox = (event) => {
	// 	setState({ ...state, [event.target.name]: event.target.checked });
	// };
	// const [state, setState] = useState({ marital: 0 });
	// const handleChange = (event) => {
	// 	setState({ ...state, [event.target.name]: event.target.value });
	// };
	// const skip = (event) => {
	// 	setUpperState({ ...upperState, step: 2 });
	// };

	// useEffect(() => {
	// 	console.log("useEffect", state);
	// 	if (state.birth_place !== undefined && state.birth_date !== undefined && state.marital !== undefined && state.marital > 0) {
	// 		setComplete(true);
	// 	} else {
	// 		setComplete(false);
	// 	}
	// }, [state]);
	// const manageSubmit = () => {
	// 	setBackDrop(true);
	// 	console.log(state);
	// 	const requestOptions = {
	// 		method: "POST",
	// 		headers: { "Content-Type": "application/json" },

	// 		body: JSON.stringify(state),
	// 	};

	// 	fetch("/api/847d6572e8b0437e9820caa5e41d7a1e", requestOptions)
	// 		.then((response) => {
	// 			return response.json();
	// 		})
	// 		.then((res) => {
	// 			switch (res.res) {
	// 				case "ok":
	// 					//setUpperState({ ...upperState, step: 2 });
	// 					location.replace("/devenir-vendeur/3");
	// 					break;

	// 				case "err":
	// 					setBackDrop(false);
	// 					setSnackState({
	// 						open: true,
	// 						body: res.reason,
	// 						severity: "error",
	// 					});
	// 					break;
	// 				default:
	// 					break;
	// 			}
	// 		});
	// };
	// const classes = useStyles();

	// const [open, setOpen] = useState(false);


	// console.log(state);
	// return (
	// 	<div style="padding-right: 150px; padding-left: 150px;">
	// 		<div style="margin-top: 20px; margin-bottom: 20px;">
	// 			<Typography variant="h5">Etat civil</Typography>
	// 		</div>
	// 		<div>
	// 			<DatePicker
	// 				id="birth_date"
	// 				name="birth_date"
	// 				autoOk
	// 				variant="inline"
	// 				inputVariant="outlined"
	// 				label="Date de naissance *"
	// 				format="dd/MM/yyyy"
	// 				disableFuture
	// 				value={state.birth_date}
	// 				InputAdornmentProps={{ position: "end" }}
	// 				onChange={(date) => {

	// 					let today = new Date(date);

	// 					console.log("date is", date, today)
	// 					setState({
	// 						...state,
	// 						birth_date: date,
	// 					});
	// 				}}
	// 				dense
	// 			/>
	// 		</div>
	// 		<div>
	// 			<TextField
	// 				id="birth_place"
	// 				name="birth_place"
	// 				variant="outlined"
	// 				style={{
	// 					marginLeft: 0,
	// 					marginRight: 10,
	// 				}}
	// 				placeholder="Lieu de naissance *"
	// 				fullWidth
	// 				margin="dense"
	// 				value={state.birth_place}
	// 				onChange={handleChange}
	// 			/>
	// 		</div>
	// 		<div style="margin-top: 20px;">
	// 			<span style="margin-right: 20px;">
	// 				<Typography variant="h6" display="inline">
	// 					Situation maritale
	// 				</Typography>
	// 			</span>
	// 			{/* <Select
	// 				labelId="marital"
	// 				id="marital"
	// 				name="marital"
	// 				open={open}
	// 				onClose={handleClose}
	// 				onOpen={handleOpen}
	// 				value={state.marital}
	// 				onChange={handleChange}
	// 			>
	// 				<MenuItem value={0}>
	// 					<em>Choisir</em>
	// 				</MenuItem>
	// 				<MenuItem value={1}>Célibataire/Divorcé{upperState.gender === "1" ? "e" : ""}</MenuItem>
	// 				<MenuItem value={2}>
	// 					Marié{upperState.gender === "1" ? "e" : ""}/Pacsé{upperState.gender === "1" ? "e" : ""}
	// 				</MenuItem>
	// 			</Select> */}
	// 		</div>
	// 		<Box display="flex" alignItems="center" justifyContent="flex-end" p={1} m={1} style="padding: 0px; margin: 0px;">
	// 			<Box p={1} style="padding: 0px; margin: 0px;">
	// 				<Button onClick={manageSubmit} disabled={!complete}>
	// 					Suivant
	// 				</Button>
	// 			</Box>
	// 		</Box>
	// 	</div>
	// );
}
